<template>
  <app-autocomplete
    filter
    :items="items"
    :label="$t('permanentDebts.subject')"
    label-icon="icon-text"
    hide-details
    multiple
    dense
    solo
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { NAMESPACE } from '@/modules/PermanentDebts/store';
import { mapActions } from 'vuex';

export default {
  name: 'SubjectSelect',

  data: () => ({
    items: []
  }),

  methods: mapActions(NAMESPACE, ['fetchFilterSubjects']),

  async created() {
    const { data } = await this.fetchFilterSubjects();
    this.items = data;
  }
};
</script>
